<template>
  <button :disabled="disabled" :class="buttonClass" class="y-button" @click.prevent="handleClick">
    <i v-if="icon" :class="icon" class="y-button-icon"></i>
    <span><slot /></span>
  </button>
</template>
<script>
  export default {
    name: 'FddButton',
    props: {
      type: {
        type: String,
        default: 'default'
      },
      disabled: {
        type: Boolean,
        default: false
      },
      icon: String,
      plain: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      buttonClass() {
        const { type, disabled, plain } = this
        return ['y-button-' + type, { 'is-disabled': disabled }, { 'is-plain': plain }]
      }
    },
    methods: {
      handleClick(e) {
        this.$emit('click', e)
      }
    }
  }
</script>
<style scoped lang="less">
  @fontColor: #276ef9;
  @hoverColor: #75a3ff;

  .y-button {
    background: #ffffff;
    padding: 0 16px;
    border-radius: 4px;
    border: 1px solid transparent;
    letter-spacing: 1px;
    cursor: pointer;
    font-size: 12px;
    line-height: 26px;

    &-icon {
      margin-right: 8px;
      font-size: 14px;
    }

    & ~ & {
      margin-left: 8px;
    }

    &-default {
      border: 1px solid #e6e8ea;

      &:hover {
        border-color: @fontColor;
        color: @fontColor;
      }

      &.is-disabled {
        border-color: #f5f6fa;
        color: #989da8;
      }
    }

    &-primary {
      background: @fontColor;
      color: white;

      &:hover {
        background: @hoverColor;
      }

      &.is-plain {
        background: white;
        color: @fontColor;
        border-color: @fontColor;

        &:hover {
          color: white;
          background: @fontColor;
          border-color: transparent;
        }
      }

      &.is-disabled {
        background-color: #d4e6fe;
        border-color: transparent;
        color: #ffffff;
      }
    }

    &-warning {
      background: #ffc600;
      color: #012969;

      &:hover {
        background: #fed547;
      }
    }

    &-text {
      color: @fontColor;
      padding: 0;
      font-size: 14px;

      &:hover {
        color: #75a3ff;
      }

      &.is-disabled {
        color: #bed4fe;
        border-color: transparent;

        &:hover {
          color: #bed4fe;
          cursor: not-allowed;
          border-color: transparent;
        }
      }
    }
  }

  .is-disabled {
    cursor: not-allowed;
  }
</style>
